@if (displayHeader) {
  <h1 class="mb-3">Создание физического лица</h1>
}
@if (form) {
  <app-physical-create-fields [(form)]="form" (dataChange)="data = $event"></app-physical-create-fields>
}
<div class="row no-gutters gutters-2 mt-3">
  <div class="col-8">
    <button type="submit" class="button" (click)="onSubmit()" [disabled]="!form.valid">Сохранить и закрыть</button>
  </div>
  <div class="col-4 text-right">
    <button type="button" class="button button_sm" (click)="onCancelClick()">Отмена</button>
  </div>
</div>
